"use client";

import { IconAlertTriangle } from "@tabler/icons-react";
import { toast } from "sonner";
import { ConfirmDialog } from "@/components/confirm-dialog";

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function UsersDeleteAllDialog({ open, onOpenChange }: Readonly<Props>) {
  const handleDeleteAll = () => {
    onOpenChange(false);
    toast(
      "You would integrate an API call to delete all or selected rows here.",
      {
        description: "All users have been deleted (mock).",
      },
    );
  };

  return (
    <ConfirmDialog
      open={open}
      onOpenChange={onOpenChange}
      handleConfirm={handleDeleteAll}
      title={
        <span className="text-destructive flex items-center gap-1">
          <IconAlertTriangle
            className="stroke-destructive inline-block"
            size={18}
          />
          Delete All Users
        </span>
      }
      desc={
        <div className="space-y-4">
          <p>
            Are you sure you want to delete all users? This action cannot be
            undone.
          </p>
        </div>
      }
      confirmText="Delete"
      destructive
    />
  );
}
